export default function cloudFunctionsEndpoint() {
  return process.env.REACT_APP_CLOUD_FUNCTIONS
}
